import { render } from "./chart.vue?vue&type=template&id=5c8b43e3&scoped=true"
import script from "./chart.vue?vue&type=script&lang=js"
export * from "./chart.vue?vue&type=script&lang=js"

import "./chart.vue?vue&type=style&index=0&id=5c8b43e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c8b43e3"]])

export default __exports__